import _Symbol from "core-js/library/fn/symbol/index.js";
import _Symbol$iterator from "core-js/library/fn/symbol/iterator.js";
import _Array$from from "core-js/library/fn/array/from.js";
function _iterableToArray(r) {
  if ("undefined" != typeof _Symbol && null != r[_Symbol$iterator] || null != r["@@iterator"]) return _Array$from(r);
}
export { _iterableToArray as default };